// extracted by mini-css-extract-plugin
export default {"heading":"ResourceList_heading__h64eI","resourceList":"ResourceList_resourceList__-0rLd"};